// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Checkbox$OrcaPaymentPage from "./Checkbox.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as InstallmentOptionItem$OrcaPaymentPage from "./InstallmentOptionItem.bs.js";
import * as InstallmentPlanDetails$OrcaPaymentPage from "./InstallmentPlanDetails.bs.js";

function InstallmentOptions(props) {
  var setErrorString = props.setErrorString;
  var errorString = props.errorString;
  var setShowInstallments = props.setShowInstallments;
  var showInstallments = props.showInstallments;
  var setSelectedInstallmentPlan = props.setSelectedInstallmentPlan;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var installmentOptions = Core__Option.getOr(paymentMethodListValue.intent_data.installment_options, []);
  var currency = paymentMethodListValue.intent_data.currency;
  var match$1 = React.useState(function () {
        
      });
  var setSelectedIndex = match$1[1];
  var selectedIndex = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsDropdownOpen = match$2[1];
  var isDropdownOpen = match$2[0];
  var match$3 = React.useState(function () {
        
      });
  var setItemHeight = match$3[1];
  var itemHeight = match$3[0];
  var match$4 = React.useState(function () {
        return 0.0;
      });
  var setThumbTop = match$4[1];
  var match$5 = React.useState(function () {
        return 100.0;
      });
  var setThumbHeightPct = match$5[1];
  var scrollContainerRef = React.useRef(null);
  var allPlans = PaymentUtils$OrcaPaymentPage.filterInstallmentPlansByPaymentMethod(installmentOptions, props.paymentMethod);
  var needsScroll = allPlans.length > 3;
  var selectedPlan = Core__Option.flatMap(selectedIndex, (function (i) {
          return allPlans[i];
        }));
  React.useEffect((function () {
          var timerId = {
            contents: undefined
          };
          var scrollHandler = {
            contents: undefined
          };
          if (needsScroll && isDropdownOpen) {
            var container = scrollContainerRef.current;
            if (!(container == null)) {
              var updateScrollbar = function () {
                var scrollHeight = container.scrollHeight;
                var clientHeight = container.clientHeight;
                if (!(scrollHeight > 0.0 && clientHeight > 0.0 && scrollHeight > clientHeight)) {
                  return ;
                }
                var ratio = clientHeight / scrollHeight;
                setThumbHeightPct(function (param) {
                      return ratio * 100.0;
                    });
                var maxScroll = scrollHeight - clientHeight;
                var currentScroll = container.scrollTop;
                var scrollPos = maxScroll > 0.0 ? currentScroll / maxScroll : 0.0;
                var trackAvailable = 100.0 - ratio * 100.0;
                setThumbTop(function (param) {
                      return scrollPos * trackAvailable;
                    });
              };
              var firstChild = container.firstElementChild;
              if (!(firstChild == null)) {
                var height = firstChild.offsetHeight;
                if (height > 0.0) {
                  setItemHeight(function (param) {
                        return height;
                      });
                }
                
              }
              scrollHandler.contents = updateScrollbar;
              container.addEventListener("scroll", updateScrollbar);
              timerId.contents = Caml_option.some(setTimeout((function () {
                          updateScrollbar();
                        }), 50));
            }
            
          } else {
            setThumbTop(function (param) {
                  return 0.0;
                });
            setThumbHeightPct(function (param) {
                  return 100.0;
                });
            setItemHeight(function (param) {
                  
                });
          }
          return (function () {
                    var id = timerId.contents;
                    if (id !== undefined) {
                      clearTimeout(Caml_option.valFromOption(id));
                    }
                    var match = scrollContainerRef.current;
                    var match$1 = scrollHandler.contents;
                    if (!(match == null) && match$1 !== undefined) {
                      match.removeEventListener("scroll", match$1);
                      return ;
                    }
                    
                  });
        }), [
        isDropdownOpen,
        needsScroll
      ]);
  var handleToggle = function (isChecked) {
    setShowInstallments(function (param) {
          return isChecked;
        });
    setErrorString(function (param) {
          return "";
        });
    if (isChecked) {
      return setIsDropdownOpen(function (param) {
                  return true;
                });
    } else {
      setSelectedInstallmentPlan(function (param) {
            
          });
      setSelectedIndex(function (param) {
            
          });
      return setIsDropdownOpen(function (param) {
                  return false;
                });
    }
  };
  var isPlanSelected = function (index) {
    return Core__Option.getOr(Core__Option.map(selectedIndex, (function (selected) {
                      return selected === index;
                    })), false);
  };
  var cleanUpStates = function () {
    setSelectedInstallmentPlan(function (param) {
          
        });
    setSelectedIndex(function (param) {
          
        });
    setShowInstallments(function (param) {
          return false;
        });
    setErrorString(function (param) {
          return "";
        });
    setIsDropdownOpen(function (param) {
          return false;
        });
  };
  React.useEffect((function () {
          cleanUpStates();
          return cleanUpStates;
        }), []);
  var toggleDropdown = function (param) {
    setIsDropdownOpen(function (prev) {
          return !prev;
        });
  };
  var scrollContainerMaxHeight = Core__Option.mapOr(needsScroll ? itemHeight : undefined, "none", (function (height) {
          return (height * 3.5).toString() + "px";
        }));
  var fadeHeight = itemHeight !== undefined ? (itemHeight * 0.25).toString() + "px" : "24px";
  var renderDropdownTrigger = function () {
    if (!isDropdownOpen && selectedPlan !== undefined) {
      return React.createElement("div", {
                  className: "flex items-center gap-2 flex-1 min-w-0"
                }, React.createElement(InstallmentPlanDetails$OrcaPaymentPage.make, {
                      plan: selectedPlan,
                      currency: currency
                    }));
    }
    return React.createElement("span", {
                className: "flex-1 text-left opacity-50",
                style: {
                  color: themeObj.colorText,
                  fontSize: themeObj.fontSizeLg
                }
              }, localeString.installmentSelectPlanPlaceholder);
  };
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: allPlans.length !== 0,
              children: React.createElement("div", {
                    className: "w-full flex flex-col",
                    style: {
                      color: themeObj.colorText,
                      fontSize: themeObj.fontSizeLg,
                      fontWeight: themeObj.fontWeightNormal
                    }
                  }, React.createElement("div", {
                        className: "flex items-center"
                      }, React.createElement(Checkbox$OrcaPaymentPage.make, {
                            isChecked: showInstallments,
                            onChange: handleToggle,
                            label: localeString.installmentPayInInstallments
                          })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                        condition: showInstallments,
                        children: React.createElement("div", {
                              className: "overflow-hidden",
                              style: {
                                border: "1px solid " + themeObj.borderColor,
                                marginTop: themeObj.spacingUnit,
                                borderRadius: themeObj.borderRadius
                              }
                            }, React.createElement("div", {
                                  className: "flex items-center gap-2 cursor-pointer w-full",
                                  style: {
                                    backgroundColor: themeObj.colorBackground,
                                    padding: "calc(" + themeObj.spacingUnit + " * 0.8) " + themeObj.spacingUnit
                                  },
                                  onClick: toggleDropdown
                                }, renderDropdownTrigger(), React.createElement("div", {
                                      className: "shrink-0 flex items-center ml-0.5 transition-transform duration-200 ease-in-out " + (
                                        isDropdownOpen ? "rotate-180" : "rotate-0"
                                      ),
                                      style: {
                                        color: themeObj.colorTextSecondary
                                      }
                                    }, React.createElement(Icon$OrcaPaymentPage.make, {
                                          name: "arrow-down",
                                          size: 12
                                        }))), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                  condition: isDropdownOpen,
                                  children: React.createElement("div", {
                                        className: "relative",
                                        style: {
                                          backgroundColor: themeObj.colorBackground,
                                          borderTop: "1px solid " + themeObj.borderColor
                                        }
                                      }, React.createElement("div", {
                                            ref: Caml_option.some(scrollContainerRef),
                                            className: "flex flex-col " + (
                                              needsScroll ? "overflow-y-auto no-scrollbar" : ""
                                            ),
                                            style: {
                                              maxHeight: scrollContainerMaxHeight
                                            }
                                          }, allPlans.map(function (plan, i) {
                                                var isLastItem = (allPlans.length - 1 | 0) === i;
                                                return JsxPPXReactSupportU.createElementWithKey(i.toString(), InstallmentOptionItem$OrcaPaymentPage.make, {
                                                            plan: plan,
                                                            currency: currency,
                                                            isSelected: isPlanSelected(i),
                                                            onSelect: (function () {
                                                                setSelectedInstallmentPlan(function (param) {
                                                                      return plan;
                                                                    });
                                                                setSelectedIndex(function (param) {
                                                                      return i;
                                                                    });
                                                                setErrorString(function (param) {
                                                                      return "";
                                                                    });
                                                                setIsDropdownOpen(function (param) {
                                                                      return false;
                                                                    });
                                                              }),
                                                            isLastItem: isLastItem
                                                          });
                                              })), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                            condition: needsScroll,
                                            children: null
                                          }, React.createElement("div", {
                                                className: "absolute bottom-0 left-0 right-0 pointer-events-none",
                                                style: {
                                                  background: "linear-gradient(to top, " + themeObj.colorBackground + ", transparent)",
                                                  height: fadeHeight,
                                                  borderRadius: "0 0 " + themeObj.borderRadius + " " + themeObj.borderRadius
                                                }
                                              }), React.createElement("div", {
                                                className: "absolute top-0 bottom-0 right-0 pointer-events-none mr-px",
                                                style: {
                                                  width: "3px",
                                                  borderRadius: themeObj.borderRadius
                                                }
                                              }, React.createElement("div", {
                                                    className: "absolute left-0 right-0 min-h-4 opacity-[0.15]",
                                                    style: {
                                                      backgroundColor: themeObj.colorText,
                                                      height: match$5[0].toString() + "%",
                                                      top: match$4[0].toString() + "%",
                                                      borderRadius: themeObj.borderRadius
                                                    }
                                                  }))))
                                }))
                      }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                        condition: errorString !== "",
                        children: React.createElement("div", {
                              className: "Error pt-1",
                              style: {
                                color: themeObj.colorDangerText,
                                fontSize: themeObj.fontSizeSm,
                                textAlign: "left",
                                alignSelf: "start"
                              }
                            }, errorString)
                      }))
            });
}

var make = InstallmentOptions;

export {
  make ,
}
/* react Not a pure module */
